export const stockStatus = {
  OUT_OF_STOCK: 'out of stock',
  IN_STOCK: 'in stock',
};

export const deviceType = {
  MOBILE: 'mobile',
  DESKTOP: 'desktop',
};

export const deviceBreakpoint = {
  // mobile is lower than 480px
  MOBILE: 480,
};

export const layoutMode = {
  FULL: 'full',
  CIRCULATIVE_HORIZONTAL_SCROLL: 'circulative_horizontal_scroll',
  HORIZONTAL_SCROLL: 'horizontal_scroll',
};

export const apiAcceptPageType = {
  PRODUCT_DETAIL: 'product_detail',
  CATEGORY: 'category_product',
  SEARCH_PRODUCT: 'search_product',
  ALL_PRODUCT: 'all_product',
};

// pageIdentify value -> PDP: product_detail, PLP: category, product_list, PLP home page: home
export const pageIdentifyMappingApiPageType = {
  product_detail: apiAcceptPageType.PRODUCT_DETAIL,
  category: apiAcceptPageType.CATEGORY,
  product_list: apiAcceptPageType.ALL_PRODUCT,
  search_product: apiAcceptPageType.SEARCH_PRODUCT,
  home: apiAcceptPageType.ALL_PRODUCT,
};

export const eventTrackingAcceptPageType = {
  PRODUCT_DETAIL: 'product_detail',
  CATEGORY_PAGE: 'category_page',
  SEARCH: 'search',
  ALL_PRODUCTS: 'all_products',
};

export const pageIdentifyMappingEventTrackingPageType = {
  product_detail: eventTrackingAcceptPageType.PRODUCT_DETAIL,
  category: eventTrackingAcceptPageType.CATEGORY_PAGE,
  product_list: eventTrackingAcceptPageType.ALL_PRODUCTS,
  search_product: eventTrackingAcceptPageType.SEARCH,
  home: eventTrackingAcceptPageType.ALL_PRODUCTS,
};

export const defaultLayoutStyle = {
  desktop: layoutMode.FULL,
  mobile: layoutMode.FULL,
};

export const productListTargetId = 'relatedProductList';
export const sectionTargetId = 'relatedProduct';
